<template>
  <el-dialog :title="isEdit?'编辑模型分类':'添加模型分类'"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">
    <el-form :model="cateForm" :rules="rules" ref="cateForm" label-width="80px">
      <el-form-item label="分类名称" :rules="[{ required: true, message: '请输入分类名称', trigger: 'blur' }]">
        <el-input v-model="cateForm.name" placeholder="请输入分类名称"></el-input>
      </el-form-item>
      <el-form-item label="岗位">
        <el-select v-model="cateForm.postIds" multiple placeholder="请选择分类类型">
          <el-option
            v-for="item in posts"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input type="textarea" v-model="cateForm.description" placeholder="请输入分类描述"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="doClose()" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="saveCategory()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { get, save, update} from '@/api/rep/category'
import { fetchPost} from '@/api/rep/post'

export default {
  props: {
    visible: false,
    echoId: null
  },
  computed: {
    ...mapGetters(['user', 'company']),
    isEdit() {
      return this.echoId
    }
  },
  data: function() {
    return {
      options: [],
      dialogVisible: false,
      props: {
        value: 'id',
        label: 'name',
        children: 'childrens',
        checkStrictly: true
      },
      parentIdEcho: [0],
      cateForm: {},
      posts:[]
    }
  },
  methods: {
    init() {
      this.getPosts()
      if (this.isEdit) {
        get(this.echoId).then(res =>{
          this.cateForm = res.data.result
        })
      } else {
        this.cateForm= {}
      }
    },
    getPosts(){
      fetchPost().then(res =>{
        this.posts = res.data.result
      })
    },
    saveCategory() {
      this.$refs['cateForm'].validate(valid => {
        if (valid) {
          this.cateForm.parentId = this.parentIdEcho[this.parentIdEcho.length - 1]
          this.cateForm.parentIds = this.parentIdEcho.join(',')
          if (this.isEdit) {
            update(this.cateForm).then(resp => {
              this.submitCallback(resp)
            })
          } else {
            save(this.cateForm).then(resp => {
              this.submitCallback(resp)
            })
          }
        }
      })
    },
    submitCallback(resp) {
      this.$message.success(resp.data.message)
      this.$emit('done', true)
    },
    doClose() {
      console.info('xxxxxxxxxxx')
      this.$emit('done', false)
    }
  }
}
</script>
